import styled from "styled-components"


export const FOOTER_HOME_H3F = styled.h3`
font-size: 16px;
color : #3D4853;
`

export const Plinkone2 = styled.p`

  color: #5a6b7b;
  font-size: 16.4px;
  &:hover {
    color: #03a9f4;
  }
`;